import agencyApi from 'api/agencyApi';
import DealerHelper from './dealerHelper';

const { createSlice, createAsyncThunk } = require('@reduxjs/toolkit');

// ---- thunks ----
// lay danh sach dai ly
export const thunkGetAgencyList = createAsyncThunk(
  'agency/thunkGetAgencyList',
  async ({ params }, thunkAPI) => {
    const res = await agencyApi.getAgencyList(params);
    return { res, role: params.role };
  }
);

// ---- params ----
const initialState = {
  isGettingData: false,
  saleList: [],
  saleTotal: 0,
  investorList: [],
  investorTotal: 0,
  groupList: [],
  groupTotal: 0,
  landlordList: [],
  landlordTotal: 0,
  chargePointPartnerList: [],
  chargePointPartnerTotal: 0,
  voucherPartnerList: [],
  voucherPartnerTotal: 0,
};

const agencySlice = createSlice({
  name: 'agency',
  initialState,
  reducers: {
    resetAgencyState: (state) => {
      Object.assign(state, initialState);
    },
  },
  extraReducers: {
    [thunkGetAgencyList.pending]: (state, action) => {
      state.isGettingData = true;
    },
    [thunkGetAgencyList.rejected]: (state, action) => {
      state.isGettingData = false;
    },
    [thunkGetAgencyList.fulfilled]: (state, action) => {
      state.isGettingData = false;
      const { res, role } = action.payload;
      const { result, agencies, total, revenue } = res;
      if (result === 'success') {
        const roleStateMap = {
          SALE: { list: 'saleList', total: 'saleTotal' },
          INVESTOR: { list: 'investorList', total: 'investorTotal' },
          GROUP: { list: 'groupList', total: 'groupTotal' },
          LANDLORD: { list: 'landlordList', total: 'landlordTotal' },
          CHARGEPOINT: { list: 'chargePointPartnerList', total: 'chargePointPartnerTotal' },
          VOUCHER_PARTNER: { list: 'voucherPartnerList', total: 'voucherPartnerTotal' },
        };

        const updatedAgencies = DealerHelper.mergeRevenueIntoAgencies(agencies, revenue);

        if (roleStateMap[role]) {
          state[roleStateMap[role].list] = updatedAgencies ?? [];
          state[roleStateMap[role].total] = total ?? 0;
        }
      }
    },
  },
});

const { reducer, actions } = agencySlice;
export const { resetAgencyState } = actions;
export default reducer;
